import MoreHorizontalRegular from "owa-fluent-icons-svg/lib/icons/MoreHorizontalRegular";
import loc from "owa-localize";
import { observer } from "owa-mobx-react";
import { Button, Menu, MenuList, MenuPopover, MenuTrigger, mergeClasses, Tooltip, } from "@fluentui/react-components";
/* eslint-disable-next-line @fluentui/react-components/prefer-fluentui-v9 -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE! Substitute this line with an explanation or resolve the problem by using v9 components instead
 *	> Avoid using Icon from '@fluentui/react', as this package has already migrated to Fluent UI 9. Use a JSX SVG icon from '@fluentui/react-icons' instead. */
import { Icon } from "@fluentui/react/lib/Icon";
import MoreMenuListItems from "./MoreMenuListItems";
import { moreButtonLabel } from "./PlacesMoreDropdown.locstring.json";
import { placesMoreButton, placesMoreButtonMargin } from "./PlacesMoreDropdown.scss";
import type { FunctionComponent } from "react";

const MoreHorizontalIcon = <Icon iconName={MoreHorizontalRegular}/>;

export interface PlacesMoreDropdownProps {
    isStandaloneApp: boolean;
}
const defaultExport: FunctionComponent<PlacesMoreDropdownProps> = observer(function PlacesMoreDropdown({ isStandaloneApp }: PlacesMoreDropdownProps) {
    const telemetryId = "SettingsAndMoreButton";
    
    return (<Menu defaultOpen={false}>
                <Tooltip content={loc(moreButtonLabel)} relationship="label" positioning="below" withArrow={true}>
                    <MenuTrigger disableButtonEnhancement={true}>
                        <Button className={isStandaloneApp
            ? mergeClasses(placesMoreButton, placesMoreButtonMargin)
            : placesMoreButton} icon={MoreHorizontalIcon} appearance="subtle" data-telemetry-id={telemetryId} aria-label={loc(moreButtonLabel)} tabIndex={0}></Button>
                    </MenuTrigger>
                </Tooltip>

                <MenuPopover>
                    <MenuList>
                        <MoreMenuListItems telemetryParentId={telemetryId}/>
                    </MenuList>
                </MenuPopover>
            </Menu>);
}, "PlacesMoreDropdown");
export default defaultExport;
